import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {Link} from 'gatsby';

function Contentsection(props) {
    return (
        <div className="tekrevol_contentsection p-100">
            <Container>
                <Row>
                    <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
                        <div className="example" data-text="LMS Solutions">
                            <h2>Learning Management System Development</h2>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="offset-lg-1">
                        <p>With years in the industry, we are on a mission to create LMS for companies through emerging
                            technologies for turnkey SaaS solutions, and high-end mobile apps. Our LMS developers are
                            part of this impact team and can help you achieve higher ROEI (Return on Employee
                            Investment), TekRevol’s dedicated e-learning management systems that do more than assigning
                            and tracking employee training.</p>
                        <Link to="/contact"
                              className="border_btn" aria-label="TekRevol Contact">Let's Connect!</Link>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Contentsection;